import axios from 'axios';
import { UCP_PROXY_PATH_PREFIX } from 'src/modules/global-vars';
import { getAccessTokenFromStorage } from 'src/stores/Authentication';

// Derived from the shared prefix so it cannot drift from the interceptor's exclusion rule.
const UCP_PDF_PROXY_PATTERN = `${UCP_PROXY_PATH_PREFIX}pdf?path=`;

export const isUcpPdfUrl = (url: string | undefined): boolean => !!url?.includes(UCP_PDF_PROXY_PATTERN);

/**
 * Opens a UCP-authenticated PDF in a new browser tab.
 *
 * window.open is called synchronously inside the user-gesture event so popup
 * blockers are satisfied. The Bearer token is added to the axios request so
 * the Java BE proxy can authenticate against UCP. The blob URL is then set on
 * the pre-opened window — browsers render application/pdf blobs inline.
 *
 * Falls back to a direct window.open for non-UCP URLs or when no token exists.
 */
export const openAuthenticatedPdf = (url: string): void => {
  const token = getAccessTokenFromStorage();

  if (!token || !isUcpPdfUrl(url)) {
    window.open(url, '_blank', 'noreferrer');
    return;
  }

  // Open synchronously inside the user-gesture to pass popup blockers.
  const win = window.open('about:blank', '_blank');

  axios
    .get<Blob>(url, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      const blobUrl = URL.createObjectURL(res.data);
      if (win) {
        win.location.href = blobUrl;
      }
      // Give the browser time to load the blob before revoking.
      setTimeout(() => URL.revokeObjectURL(blobUrl), 10_000);
    })
    .catch(() => {
      if (win) {
        win.close();
      }
    });
};
